import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { refreshSession } from '/business/shared/state/actions/auth';

type RefreshSessionThunk = ReturnType<typeof refreshSession>;
type SharedDispatch = (action: RefreshSessionThunk) => ReturnType<RefreshSessionThunk>;

export default function useRefreshSession(dispatch: SharedDispatch) {
  const { pathname } = useLocation();

  return useEffect(() => {
    dispatch(refreshSession());
  }, [dispatch, pathname]);
}
